import { render, staticRenderFns } from "./ProfileQuickInfo.vue?vue&type=template&id=b0b11bf8&scoped=true"
import script from "./ProfileQuickInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileQuickInfo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileQuickInfo.vue?vue&type=style&index=0&id=b0b11bf8&prod&lang=scss"
import style1 from "./ProfileQuickInfo.vue?vue&type=style&index=1&id=b0b11bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b11bf8",
  null
  
)

export default component.exports